import React, { useState, useEffect } from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { SvgIcon } from "@progress/kendo-react-common";
import { xIcon } from "@progress/kendo-svg-icons";
import axios from '../../axiosConfig';
import { useMsal } from "@azure/msal-react";
import { truncateEmail } from '../../Utilities/utils';
import Toast from '../ToastNotification';
import UseAssignOrder from '../../Helpers/Hooks/UseAssignOrder';
import { GET_ORDER_DETAIL } from '../../Helpers/queries/GetOrderDetails';
import { useQueryClient } from '@tanstack/react-query';

const AssignButton = ({ field, dataItem, updateData, token, onAssignOrder, onUnassignOrder, onErrorAssign, modalError, disabled, onFetchData, employeeRole, employeeData}) => {
  const [assigned, setAssigned] = useState(dataItem[field] != 'Not Assigned' && dataItem[field] != 'Assign');
  const {accounts} = useMsal();
  const [profileImgAssigned, setProfileImgAssigned] = useState();
  const [toast, setToast] = useState(null);
  const [idtoast, setIdtoast] = useState(1);  
  const queryClient = useQueryClient();

  const downloadFile = async (imageName) => {
    setIdtoast(idtoast + 1);
    setToast({ showToast: false });
    let errorMessage;    

    if (token) {
      const downloadUrl = `/download/blob?&fileName=${encodeURIComponent(imageName)}&departmentsFolder=${encodeURIComponent("")}&departmentFolder=${encodeURIComponent("")}&orderNumFolder=${""}&containerName=${encodeURIComponent("employeeprofileimages")}&isProfileImage=${encodeURIComponent(true)}`;
      try {
        const response = await axios.get(downloadUrl, {
          headers: {
            Authorization: token,
          },
          responseType: 'blob',
        });

      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const imageUrl = URL.createObjectURL(blob);

      if (imageUrl === null) {
        setProfileImgAssigned('/DefaultProfile.png');
      }
      else {
        setProfileImgAssigned(imageUrl);
      }

      } catch (error) {
        if (error.response) {

          const status = error.response.status;
          const errorMessages = {
            401: 'Expired Token',
            500: 'The file does not exist on the blob storage'
          };

          errorMessage = errorMessages[status] || 'An error occurred';
        } else {
          errorMessage = error.message || 'An unexpected error occurred';
        }

        setToast({ showToast: true, message: errorMessage, type: 'error' });
      }
    }
  };

  const { mutate: assignOrder } = UseAssignOrder(onFetchData, onErrorAssign, onAssignOrder, modalError, downloadFile, employeeData);

  const handleAssign = (e) => {
    const updatedData = { ...dataItem, [field]: e.target.value };
    updateData(updatedData);
    setAssigned(dataItem[field]);    

    assignOrder({ dataItem, field, token, accounts, employeeRole });    
  };  

  //uncomment when needed to follow bussines Rules
  // const handleStatusChange = async (status) => {

  //   try {             
  //     const updateUrl = `/updateOrderStatus/${encodeURIComponent(dataItem.orderDetailId)}?esoiStatusId=${encodeURIComponent(status)}&Author=${encodeURIComponent(truncateEmail(accounts[0].username,50))}`;

  //     const response = await axios.put(
  //       updateUrl,
  //       null, 
  //       {
  //         headers: {
  //           Authorization: token,
  //           'Content-Type': 'application/json', 
  //         }
  //       }
  //     );     
  //     onFetchData();
  //   }
  //   catch (error) {
  //     onErrorAssign(error);
  //   };                 
  // };

  const { mutate: UnassignOrder } = UseAssignOrder(onFetchData, onErrorAssign, onAssignOrder, modalError, downloadFile, employeeData, onUnassignOrder);

  const handleUnassign = async (e) =>{
    const updatedData = { ...dataItem, [field]: e.target.value };
    
    updateData(updatedData);
    setAssigned(!dataItem[field]);  
    const isUnassign = true;

    try {
      await UnassignOrder({
        dataItem,
        field,
        token,
        accounts,
        employeeRole,
        isUnassign,
      });
    } catch (error) {
      onErrorAssign(error);
    };       
  };

  let borderColorCase;
  let colorCase;
  if (!assigned && !disabled) {
    borderColorCase = '#0097E0';
    colorCase = '#0097E0';
  } else if (!assigned && disabled) {
    borderColorCase = '#828282';
    colorCase = '#828282';
  } else {
    borderColorCase = 'transparent';
    colorCase = '#4C4C4C';
  }

  return (
    <div>
    {toast && <Toast key={idtoast} showToast={toast.showToast} message={toast.message} type={toast.type} />}

    <td style={{display: 'flex', flexDirection: 'row', gap:'5px', alignItems: 'center', background: dataItem.selected === true ? '#D1F3FF': 'transparent' }}>
    <button
        title={dataItem[field]}
        className= 'secondary-button roboto-15-400'
        style={{
            background: 'transparent',
            justifyContent: assigned ? 'flex-start' : 'center',
            flex: 1,
            color: colorCase,
            fontWeight: assigned ? 400 : 500,
            borderColor: borderColorCase,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            padding: assigned ? '0px'  : '12px',
            cursor: assigned || disabled ? 'default' : 'pointer'
        }} 
        onClick={handleAssign} 
        disabled={assigned || disabled}>
        {assigned ? dataItem[field] : 'Assign'}
    </button>
    {!disabled && ( 
      <Button
          disabled= {disabled}
          onClick={handleUnassign}
          style={{
              justifyContent: 'flex-end',
              padding: '0px',
              paddingBottom: '2px',
              display: assigned ? 'block' : 'none' ,
              width: '24px',
              height: '24px',
              borderRadius: '180px',
              backgroundColor: '#F2F2F2',
              border: 'none',
          }}> <SvgIcon icon={xIcon} color='#8D8D8D'></SvgIcon>
      </Button> 
    )}
  </td>
  </div>
  );
};

export default AssignButton;
